import { CanvasDrawer } from "./CanvasDrawer";
import { ImageStore } from "./ImageStore";
import { v4 as uuidv4 } from "uuid";

export interface CanvasPropertyDict {
    itemID: string;
    imageID: string;
    itemIndex: number;
    TL_imageBounds: { x: number; y: number };
    BR_imageBounds: { x: number; y: number };
    selected: boolean;
    rotation: number;
    flipped: boolean;
}

export class CanvasImage {

    itemID: string;
    imageID: string;
    itemIndex: number;
    TL_imageBounds: { x: number, y: number };
    BR_imageBounds: { x: number, y: number };
    selected: boolean
    rotation: number
    flipped: boolean

    constructor(imageID: string, itemIndex: number, TL_imageBounds: { x: number, y: number }, BR_imageBounds: { x: number, y: number }) {

        this.imageID = imageID;
        this.itemIndex = itemIndex
        this.TL_imageBounds = TL_imageBounds;
        this.BR_imageBounds = BR_imageBounds;
        this.selected = false
        this.rotation = 0
        this.flipped = false
        this.itemID = uuidv4()
    }

    getInstanceDict() {
        return {
            itemID: this.itemID,
            imageID: this.imageID,
            itemIndex: this.itemIndex,
            TL_imageBounds: this.TL_imageBounds,
            BR_imageBounds: this.BR_imageBounds,
            rotation: this.rotation,
            flipped: this.flipped
        };
    }

    drawSelectorBox(ctx: CanvasRenderingContext2D) {

        const x1 = this.TL_imageBounds.x;
        const y1 = this.TL_imageBounds.y;
        const x2 = this.BR_imageBounds.x;
        const y2 = this.BR_imageBounds.y;

        const width1 = x2 - x1;
        const height1 = y2 - y1;

        const centerX = x1 + width1 / 2;
        const centerY = y1 + height1 / 2;

        ctx.save();

        ctx.translate(centerX, centerY);

        ctx.rotate(this.rotation * Math.PI / 180);

        const width = this.BR_imageBounds.x - this.TL_imageBounds.x;
        const height = this.BR_imageBounds.y - this.TL_imageBounds.y;

        ctx.strokeStyle = "white";
        ctx.lineWidth = 5;
        ctx.setLineDash([5, 3]);
        ctx.strokeRect(-width / 2, -height / 2, width, height);

        ctx.setLineDash([]);

        ctx.fillStyle = "#6b9e9e";
        const radius = 15 / CanvasDrawer.scale;

        const corners = [
            { x: -width / 2, y: -height / 2 },
            { x: width / 2, y: -height / 2 },
            { x: -width / 2, y: height / 2 },
            { x: width / 2, y: height / 2 }
        ];

        ctx.lineWidth = 3.5 / CanvasDrawer.scale

        corners.forEach(pt => {
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, radius, 0, Math.PI * 2);
            ctx.fill();
            ctx.stroke();
        });

        ctx.beginPath();
        ctx.arc(0, -height / 2 - 50, radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();

        ctx.restore();
    }

    getSelectorActionAt(x: number, y: number, tolerance: number = 100): string | null {
        const boundsX = this.TL_imageBounds.x;
        const boundsY = this.TL_imageBounds.y;
        const width = this.BR_imageBounds.x - boundsX;
        const height = this.BR_imageBounds.y - boundsY;

        const centerX = boundsX + width / 2;
        const centerY = boundsY + height / 2;

        const dx = x - centerX;
        const dy = y - centerY;
        const angleRad = -this.rotation * Math.PI / 180;

        const localX = dx * Math.cos(angleRad) - dy * Math.sin(angleRad);
        const localY = dx * Math.sin(angleRad) + dy * Math.cos(angleRad);

        const radius = tolerance;
        const points = [
            { x: -width / 2, y: -height / 2, action: "resize-tl" },
            { x: width / 2, y: -height / 2, action: "resize-tr" },
            { x: -width / 2, y: height / 2, action: "resize-bl" },
            { x: width / 2, y: height / 2, action: "resize-br" },
            { x: 0, y: -height / 2 - 50, action: "rotate" },
        ];

        for (const point of points) {
            const pdx = localX - point.x;
            const pdy = localY - point.y;
            if (Math.sqrt(pdx * pdx + pdy * pdy) <= radius) {
                return point.action;
            }
        }

        return null;
    }



    drawImage(ctx: CanvasRenderingContext2D) {
        if (!ctx) return;

        const x1 = this.TL_imageBounds.x;
        const y1 = this.TL_imageBounds.y;
        const x2 = this.BR_imageBounds.x;
        const y2 = this.BR_imageBounds.y;

        const width = x2 - x1;
        const height = y2 - y1;

        const centerX = x1 + width / 2;
        const centerY = y1 + height / 2;

        ctx.save();

        ctx.translate(centerX, centerY);

        ctx.rotate(this.rotation * Math.PI / 180);

        if (this.flipped) {
            ctx.scale(-1, 1);
        }

        let image

        for (let i = 0; i < ImageStore.namedImages.length; i++) {
            if (ImageStore.namedImages[i].imgID === this.imageID) {
                image = ImageStore.namedImages[i].img
            }
        }
        if (image)
            ctx.drawImage(image, -width / 2, -height / 2, width, height);

        ctx.restore();
    }


}